var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEaas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 522,
    height: 546,
    viewBox: "0 0 522 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_914_900)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 252,
    cy: 432,
    rx: 172,
    ry: 34,
    fill: "#2A7AD7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.622 349.72L188.31 360.284L211.364 357.433L190.636 347.093L167.622 349.72Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.676 428.243L461.002 415.052L444.25 417.4L444.84 417.965L283.179 336.439C269.238 329.371 253.839 326.655 238.321 328.53L59.2352 349.742L66.0359 347.714L44.2571 342.03L42.01 354.773C41.6947 356.562 42.3114 358.284 44.2017 359.309L217.507 446.576C231.448 453.645 246.847 456.36 262.364 454.486L455.065 431.755C457.192 431.439 458.4 429.808 458.676 428.243Z",
    fill: "#246ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.391 418.565L378.908 427.778L264.69 441.295C249.172 443.17 233.773 440.454 219.832 433.386L46.5275 346.118C42.7075 344.292 43.6931 338.703 47.9073 338.293L240.608 315.562C256.126 313.688 271.525 316.403 285.466 323.472L324.768 343.312L458.771 410.739C462.591 412.566 461.644 417.931 457.391 418.565Z",
    fill: "#2A7AD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M457.391 418.565L378.908 427.778L261.437 427.121L278.743 328.972L324.808 343.088L458.81 410.516C462.591 412.566 461.644 417.931 457.391 418.565Z",
    fill: "#0E336B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.139 398.083L400.378 399.982L401.008 400.324L277.573 338.217C267.006 332.896 255.178 330.81 243.428 332.196L106.458 348.156L111.539 346.747L95.0373 342.454L93.3422 352.068C93.1056 353.409 93.5386 354.869 95.022 355.591L227.318 422.257C237.885 427.578 249.713 429.664 261.463 428.278L408.581 410.88C410.222 410.709 411.129 409.485 411.365 408.144L413.139 398.083Z",
    fill: "#246ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8352 345.307L229.131 411.973C239.698 417.294 251.526 419.38 263.276 417.994L410.395 400.596C413.454 400.213 414.203 395.965 411.459 394.559L279.163 327.893C268.596 322.572 256.768 320.487 245.018 321.873L97.8996 339.27C94.6175 339.614 93.8685 343.862 96.8352 345.307Z",
    fill: "#5998E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.148 398.532L262.962 415.863C251.697 417.104 240.316 415.098 230.155 410.079L99.7498 344.438C98.0433 343.676 98.5163 340.993 100.381 340.86L245.372 323.779C256.636 322.538 268.018 324.545 278.179 329.564L409.621 395.849C410.92 396.309 410.566 398.321 409.148 398.532Z",
    fill: "#D0E1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.637 347.093L236.482 341.576L257.21 351.916L211.365 357.433L190.637 347.093Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.027 396.35L363.056 391.096L383.783 401.436L337.715 406.914L317.027 396.35Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.699 386.442L229.543 380.925L270.96 401.828L224.892 407.306L183.699 386.442Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.285 388.638L293.973 399.201L317.027 396.35L296.299 386.01L273.285 388.638Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.352 404.758L269.08 415.098L291.871 412.431L271.406 401.907L248.352 404.758Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.83 367.957L252.781 378.337L275.572 375.67L255.107 365.146L231.83 367.957Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.554 355.198L142.282 365.538L165.296 362.911L144.568 352.571L121.554 355.198Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.039 370.624L186.024 373.251L144.569 352.571L167.623 349.72L209.039 370.624Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.367 380.532L319.314 383.383L277.897 362.479L300.951 359.629L342.367 380.532Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.715 406.914L314.701 409.541L273.285 388.638L296.299 386.01L337.715 406.914Z",
    fill: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.1689,
    y: 344.671,
    width: 108.776,
    height: 42.4986,
    transform: "rotate(10 54.1689 344.671)",
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0615 352.885C67.4784 356.498 74.8953 360.111 82.3121 363.724L104.3 374.747L126.249 385.994C133.626 389.831 140.78 393.628 148.158 397.465C140.741 393.851 133.324 390.238 125.907 386.625L103.736 375.339L81.7869 364.092C74.5932 360.519 67.2158 356.682 60.0615 352.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.599,
    y: 402.83,
    width: 108.232,
    height: 42.4986,
    transform: "rotate(10 283.599 402.83)",
    fill: "url(#pattern1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.007 427.172C373.985 428.294 365.741 429.376 357.496 430.458L333.024 433.519L308.592 436.358C300.387 437.216 292.181 438.074 283.976 438.933C291.998 437.811 300.242 436.729 308.487 435.647L332.959 432.586L357.391 429.747C365.819 428.928 374.025 428.07 382.007 427.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.862,
    y: 390.027,
    width: 108.232,
    height: 42.4986,
    transform: "rotate(10 116.862 390.027)",
    fill: "url(#pattern2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.48 398.239C129.897 401.852 137.314 405.465 144.731 409.078L166.719 420.101L188.667 431.348C196.045 435.185 203.199 438.982 210.576 442.819C203.159 439.206 195.743 435.593 188.326 431.98L166.338 420.956L144.389 409.709C137.012 405.873 129.634 402.036 122.48 398.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.102,
    y: 385.808,
    width: 61.4585,
    height: 28.3324,
    transform: "rotate(10 165.102 385.808)",
    fill: "url(#pattern3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.068 394.127C174.888 395.954 178.524 397.517 182.121 399.304C185.718 401.09 189.538 402.917 193.135 404.704C200.512 408.54 207.706 412.114 214.821 416.135C207.364 412.745 199.948 409.132 192.531 405.519C188.934 403.732 185.153 401.682 181.556 399.896C178.222 397.925 174.625 396.138 171.068 394.127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.348,
    y: 375.686,
    width: 29.3695,
    height: 18.525,
    transform: "rotate(10 145.348 375.686)",
    fill: "url(#pattern4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.826 383.642C153.386 384.785 155.723 385.889 158.059 386.993C160.357 388.32 162.916 389.463 165.214 390.79C162.654 389.647 160.317 388.543 157.98 387.44C155.683 386.113 153.123 384.97 150.826 383.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.881,
    y: 418.95,
    width: 61.4585,
    height: 28.3324,
    transform: "rotate(10 371.881 418.95)",
    fill: "url(#pattern5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.291 435.32C420.261 435.992 416.23 436.665 412.016 437.074C407.986 437.747 403.771 438.156 399.78 438.605C391.575 439.463 383.553 440.585 375.204 440.957C383.265 439.612 391.509 438.53 399.492 437.632C403.483 437.183 407.697 436.774 411.688 436.325C416.125 435.955 420.116 435.506 424.291 435.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.283,
    y: 400.993,
    width: 61.4585,
    height: 28.3324,
    transform: "rotate(10 298.283 400.993)",
    fill: "url(#pattern6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.317 417.666C346.287 418.338 342.256 419.01 338.042 419.42C334.011 420.092 329.797 420.502 325.806 420.951C317.601 421.809 309.579 422.931 301.23 423.303C309.291 421.958 317.535 420.876 325.517 419.978C329.509 419.529 333.723 419.119 337.714 418.671C342.151 418.3 346.142 417.851 350.317 417.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.555 355.198L240.998 340.758C253.457 339.267 265.955 341.471 277.152 347.133L383.823 401.213L409.188 398.308L409.7 395.402L278.258 329.117L245.451 323.332L100.46 340.413L99.8291 343.991L121.555 355.198Z",
    fill: "#2162B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.218 329.34L262.056 336.173L245.412 323.556C256.676 322.315 268.058 324.322 278.218 329.34Z",
    fill: "#2162B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.076 342.136L99.7893 344.214C98.0828 343.452 98.5559 340.769 100.42 340.637L101.076 342.136Z",
    fill: "#2162B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.149 398.532L409.661 395.625C410.921 396.309 410.567 398.321 409.149 398.532Z",
    fill: "#2162B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M100.196 344.516L230.602 410.157C230.602 410.157 245.094 418.015 263.408 415.942C281.723 413.869 409.594 398.61 409.594 398.61L539.346 -26.6506L123.483 -109.891L100.196 344.516Z",
    fill: "url(#paint0_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.402 130.801L363.388 133.428L321.972 112.524L344.986 109.897L386.402 130.801Z",
    fill: "url(#paint1_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.485 273.649L144.569 352.571L186.024 373.251L209.039 370.624L222.955 291.702L199.94 294.33L158.485 273.649Z",
    fill: "url(#paint2_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.955 291.702L199.94 294.33L158.485 273.649L181.539 270.799L222.955 291.702Z",
    fill: "url(#paint3_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.044 126.147L227.733 136.71L250.786 133.86L230.059 123.519L207.044 126.147Z",
    fill: "url(#paint4_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.469 189.25L190.637 347.093L211.365 357.433L257.209 351.916L285.041 194.073L239.197 199.59L218.469 189.25Z",
    fill: "url(#paint5_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.469 189.25L264.313 183.733L285.041 194.073L239.196 199.59L218.469 189.25Z",
    fill: "url(#paint6_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.662 210.115L280.613 220.494L303.404 217.828L282.939 207.303L259.662 210.115Z",
    fill: "url(#paint7_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.662 210.115L231.83 367.957L252.781 378.337L275.572 375.67L303.404 217.827L280.613 220.494L259.662 210.115Z",
    fill: "url(#paint8_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.797 199.159L317.027 396.35L337.715 406.914L383.783 401.436L418.554 204.244L372.525 209.499L351.797 199.159Z",
    fill: "url(#paint9_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.972 112.524L277.898 362.48L319.315 383.383L342.368 380.532L386.403 130.801L363.388 133.428L321.972 112.524Z",
    fill: "url(#paint10_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.222 262.262L340.208 264.889L298.792 243.986L321.806 241.358L363.222 262.262Z",
    fill: "url(#paint11_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.797 199.159L397.865 193.681L418.554 204.244L372.525 209.499L351.797 199.159Z",
    fill: "url(#paint12_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.792 243.986L273.286 388.638L314.702 409.541L337.716 406.914L363.222 262.262L340.208 264.889L298.792 243.986Z",
    fill: "url(#paint13_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.044 126.147L167.622 349.72L188.31 360.284L211.364 357.433L250.786 133.86L227.732 136.71L207.044 126.147Z",
    fill: "url(#paint14_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.878 254.981L183.698 386.442L224.891 407.306L270.959 401.828L294.139 270.367L248.071 275.845L206.878 254.981Z",
    fill: "url(#paint15_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.879 254.981L252.724 249.463L294.14 270.367L248.072 275.845L206.879 254.981Z",
    fill: "url(#paint16_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.122 249.895L160.81 260.459L183.864 257.608L163.136 247.268L140.122 249.895Z",
    fill: "url(#paint17_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.122 249.895L121.554 355.198L142.282 365.538L165.296 362.911L183.864 257.608L160.81 260.459L140.122 249.895Z",
    fill: "url(#paint18_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 185.422L183.454 195.986L206.508 193.135L185.78 182.795L162.766 185.422Z",
    fill: "url(#paint19_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.766 185.422L156.301 222.088L177.029 232.428L200.043 229.801L206.508 193.135L183.454 195.986L162.766 185.422Z",
    fill: "url(#paint20_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.799 286.185L248.352 404.758L269.08 415.098L291.871 412.431L312.541 293.898L289.488 296.749L268.799 286.185Z",
    fill: "url(#paint21_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8 286.185L289.488 296.749L312.542 293.898L291.814 283.558L268.8 286.185Z",
    fill: "url(#paint22_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.083 339.898L392.811 350.238L415.826 347.611L395.137 337.047L372.083 339.898Z",
    fill: "url(#paint23_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.083 339.898L365.658 376.34L386.346 386.904L409.4 384.053L415.826 347.611L392.811 350.238L372.083 339.898Z",
    fill: "url(#paint24_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.854 293.66L130.582 304L153.597 301.373L132.908 290.809L109.854 293.66Z",
    fill: "url(#paint25_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.854 293.66L103.429 330.102L124.117 340.666L147.171 337.815L153.597 301.373L130.582 304L109.854 293.66Z",
    fill: "url(#paint26_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.924 146.307L314.613 156.871L337.443 153.98L316.938 143.68L293.924 146.307Z",
    fill: "url(#paint27_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.924 146.307L287.459 182.973L308.187 193.313L330.978 190.646L337.443 153.98L314.613 156.871L293.924 146.307Z",
    fill: "url(#paint28_linear_914_900)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_914_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.966 261.668L248.072 275.845L279.554 272.175L248.308 274.504L219.966 261.668Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_914_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.385 129.339L227.733 136.71L243.513 134.652L227.628 136L213.385 129.339Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_914_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.225 213.347L280.389 220.455L296.354 218.659L280.508 219.784L266.225 213.347Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_914_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.39 254.756L160.811 260.459L173.493 259.006L160.666 259.972L149.39 254.756Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_914_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.61 342.486L392.812 350.238L409.747 348.153L392.93 349.567L377.61 342.486Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_914_900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.361 202.391L372.526 209.499L388.49 207.703L372.604 209.052L358.361 202.391Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.469 205.775C441.644 206.159 443.719 204.706 444.102 202.53C444.486 200.355 443.033 198.28 440.858 197.896C438.682 197.513 436.607 198.965 436.224 201.141C435.84 203.317 437.293 205.391 439.469 205.775Z",
    fill: "url(#paint29_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.414 237.263C205.59 237.647 207.665 236.194 208.048 234.018C208.432 231.843 206.979 229.768 204.803 229.384C202.628 229.001 200.553 230.454 200.17 232.629C199.786 234.805 201.239 236.879 203.414 237.263Z",
    fill: "url(#paint30_linear_914_900)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.925 178.84C429.276 179.607 433.425 176.702 434.192 172.351C434.96 168 432.054 163.851 427.703 163.083C423.352 162.316 419.203 165.221 418.436 169.573C417.668 173.924 420.574 178.073 424.925 178.84Z",
    fill: "url(#paint31_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.856 119.041C134.032 119.425 136.106 117.972 136.49 115.796C136.874 113.621 135.421 111.546 133.245 111.162C131.07 110.779 128.995 112.232 128.612 114.407C128.228 116.583 129.681 118.657 131.856 119.041Z",
    fill: "url(#paint32_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.638 122.668C292.814 123.052 294.889 121.599 295.272 119.424C295.656 117.248 294.203 115.173 292.028 114.79C289.852 114.406 287.777 115.859 287.394 118.035C287.01 120.21 288.463 122.285 290.638 122.668Z",
    fill: "url(#paint33_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.37 150.883C268.546 151.266 270.621 149.814 271.004 147.638C271.388 145.463 269.935 143.388 267.76 143.004C265.584 142.621 263.509 144.073 263.126 146.249C262.742 148.425 264.195 150.499 266.37 150.883Z",
    fill: "url(#paint34_linear_914_900)",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.737 156.98C167.088 157.747 171.238 154.842 172.005 150.491C172.772 146.139 169.867 141.99 165.516 141.223C161.165 140.456 157.015 143.361 156.248 147.712C155.481 152.063 158.386 156.213 162.737 156.98Z",
    fill: "url(#paint35_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.98 103.339C159.067 103.531 160.105 102.804 160.297 101.716C160.488 100.629 159.762 99.5913 158.674 99.3995C157.586 99.2077 156.549 99.934 156.357 101.022C156.165 102.11 156.892 103.147 157.98 103.339Z",
    fill: "url(#paint36_linear_914_900)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.362 89.2444C286.45 89.4362 287.488 88.7098 287.679 87.622C287.871 86.5342 287.145 85.4969 286.057 85.3051C284.969 85.1133 283.932 85.8397 283.74 86.9274C283.548 88.0152 284.275 89.0525 285.362 89.2444Z",
    fill: "url(#paint37_linear_914_900)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.144 158.047C400.231 158.239 401.269 157.513 401.461 156.425C401.652 155.337 400.926 154.3 399.838 154.108C398.75 153.916 397.713 154.643 397.521 155.731C397.33 156.818 398.056 157.856 399.144 158.047Z",
    fill: "url(#paint38_linear_914_900)",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_914_900",
    x: 0,
    y: 318,
    width: 504,
    height: 228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_914_900"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_914_900",
    transform: "scale(0.00490196 0.0120482)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_914_900",
    transform: "scale(0.00490196 0.0120482)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_914_900",
    transform: "scale(0.005 0.0120482)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_914_900",
    transform: "scale(0.00854701 0.0185185)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_914_900",
    transform: "scale(0.0172414 0.0263158)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_914_900",
    transform: "scale(0.00854701 0.0172414)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_914_900",
    transform: "scale(0.00854701 0.0185185)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_914_900",
    x: 217.966,
    y: 259.668,
    width: 63.5874,
    height: 18.1767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_914_900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_914_900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_914_900",
    x: 211.385,
    y: 127.339,
    width: 34.1284,
    height: 11.371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_914_900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_914_900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_914_900",
    x: 264.225,
    y: 211.347,
    width: 34.1284,
    height: 11.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_914_900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_914_900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_914_900",
    x: 147.39,
    y: 252.756,
    width: 28.103,
    height: 9.70215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_914_900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_914_900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_914_900",
    x: 375.61,
    y: 340.486,
    width: 36.1372,
    height: 11.7519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_914_900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_914_900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_914_900",
    x: 356.361,
    y: 200.391,
    width: 34.1284,
    height: 11.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_914_900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_914_900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_914_900",
    x1: 246.121,
    y1: 415.263,
    x2: 281.467,
    y2: 214.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4635,
    stopColor: "#DAE8F8",
    stopOpacity: 0.5365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_914_900",
    x1: 321.468,
    y1: 115.841,
    x2: 387.068,
    y2: 127.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_914_900",
    x1: 174.997,
    y1: 371.39,
    x2: 191.23,
    y2: 279.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_914_900",
    x1: 157.849,
    y1: 276.84,
    x2: 223.449,
    y2: 288.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_914_900",
    x1: 206.958,
    y1: 126.157,
    x2: 250.678,
    y2: 133.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_914_900",
    x1: 222.187,
    y1: 359.37,
    x2: 252.333,
    y2: 188.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_914_900",
    x1: 218.962,
    y1: 185.908,
    x2: 284.544,
    y2: 197.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_914_900",
    x1: 259.784,
    y1: 210.056,
    x2: 303.504,
    y2: 217.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_914_900",
    x1: 252.656,
    y1: 378.309,
    x2: 281.643,
    y2: 213.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_914_900",
    x1: 348.71,
    y1: 408.8,
    x2: 385.813,
    y2: 198.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_914_900",
    x1: 308.469,
    y1: 381.364,
    x2: 354.848,
    y2: 118.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_914_900",
    x1: 298.278,
    y1: 247.354,
    x2: 363.879,
    y2: 258.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_914_900",
    x1: 352.442,
    y1: 195.884,
    x2: 418.024,
    y2: 207.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_914_900",
    x1: 303.83,
    y1: 407.673,
    x2: 331.658,
    y2: 249.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_914_900",
    x1: 188.235,
    y1: 360.167,
    x2: 228.817,
    y2: 130.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_914_900",
    x1: 225,
    y1: 407.327,
    x2: 250.508,
    y2: 262.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_914_900",
    x1: 206.788,
    y1: 254.953,
    x2: 294.229,
    y2: 270.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_914_900",
    x1: 140.047,
    y1: 249.965,
    x2: 183.768,
    y2: 257.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_914_900",
    x1: 142.195,
    y1: 365.609,
    x2: 161.906,
    y2: 253.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_914_900",
    x1: 162.701,
    y1: 185.459,
    x2: 206.422,
    y2: 193.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_914_900",
    x1: 176.946,
    y1: 232.505,
    x2: 184.561,
    y2: 189.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_914_900",
    x1: 268.834,
    y1: 415.056,
    x2: 290.863,
    y2: 290.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_914_900",
    x1: 268.871,
    y1: 286.24,
    x2: 312.592,
    y2: 293.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_914_900",
    x1: 372.144,
    y1: 339.816,
    x2: 415.865,
    y2: 347.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_914_900",
    x1: 386.891,
    y1: 384.018,
    x2: 393.502,
    y2: 346.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_914_900",
    x1: 109.82,
    y1: 293.561,
    x2: 153.541,
    y2: 301.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_914_900",
    x1: 124.778,
    y1: 336.561,
    x2: 131.457,
    y2: 298.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_914_900",
    x1: 293.815,
    y1: 146.331,
    x2: 337.536,
    y2: 154.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89B5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_914_900",
    x1: 308.06,
    y1: 193.376,
    x2: 315.675,
    y2: 150.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E1F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_914_900",
    x1: 436.221,
    y1: 201.157,
    x2: 444.131,
    y2: 202.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_914_900",
    x1: 200.167,
    y1: 232.645,
    x2: 208.077,
    y2: 234.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_914_900",
    x1: 418.43,
    y1: 169.604,
    x2: 434.249,
    y2: 172.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_914_900",
    x1: 128.609,
    y1: 114.423,
    x2: 136.518,
    y2: 115.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_914_900",
    x1: 287.391,
    y1: 118.05,
    x2: 295.301,
    y2: 119.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_914_900",
    x1: 263.123,
    y1: 146.265,
    x2: 271.033,
    y2: 147.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_914_900",
    x1: 156.243,
    y1: 147.743,
    x2: 172.062,
    y2: 150.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_914_900",
    x1: 156.356,
    y1: 101.03,
    x2: 160.311,
    y2: 101.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_914_900",
    x1: 283.739,
    y1: 86.9352,
    x2: 287.694,
    y2: 87.6326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_914_900",
    x1: 397.52,
    y1: 155.738,
    x2: 401.475,
    y2: 156.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5998E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B5E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 424,
    height: 424,
    fill: "white",
    transform: "translate(104.034 0.407349) rotate(10)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_914_900",
    width: 204,
    height: 83,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_914_900",
    width: 204,
    height: 83,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_914_900",
    width: 200,
    height: 83,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_914_900",
    width: 117,
    height: 54,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAA2CAYAAAD5yNZ+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABGFJREFUeNrsnAtu2zAMhiXZd9n9j7OzLBK3AXGhsnzKjqPYJCDYbhC38Bf+fClNKSwsLCzsDZb33uA3gHQf+JVzPOVPgMqAxNcQoD8AKgEzO6FCQJ4IKgLKHTkDBioE4DdBFYD2i7tfD5SCCwH5WFud8LNxcR4KaGHY3AcqIL8AKga8rfJcuTv2YDmY0pLice4gB+BR+e2kNyN4G9ClOy/IqzGk1sFrA5BDqg/y1Mz8rAfaHyUZ5qB6YH95Lb4OL/bHVG5RcIsgwxhaMx6llbHn3hnwOvg+To4lj+XiKwVRO+e8mvLi2yVb60H3oZKnbSUizlKAMTy8QPiZ1YtvIdOjUEFJWjhvxq974VYBuiUu30KmVwfExABoz4fVnxf0IC3NCgyYgluJ8zoA+dIyvRqBZsFbN5CVgAXddUMeW5hMmbr/BkWCWh2efGmZtrYJMyplcJ2K10q8xtW1VLacFGVoDFAJcHXItNjKnB2wR34zUXNyDx+eoPqHugGF7tgb1ZnaA5cCXAdlOn1SHPZMabjYSHkd1ZRYmGvKm4sgzyAA5oDWHTLdhM7WlF2tvaO3IrQPOcjWVYT2o+S9lYDsATwq09MAPmJIznWZJMDSWgmvLsb+Mq5dRwFXpVaeOg4fsZ2FkmXKizXvXQW4HGAu25bi76hMV2ccfhvg4bsLW1uk2WsZ8N6VkeaFSK6k2rcNynRlyifOe9u7Ab9qNyEGy7USs1Oae8jFmFxlBTAn0z3AhyPZ4iCfBvjQj4lhYxoGbIm9RYFK1cFZ8WKLTGOAD8GDJYk+HfDLxN0JuAiQF2MGXZRGx4hMa5KsSTMn05JE786iT0nJjIAtGfRi8GTJi0dkujlibzNm0yC0LrkyyQz39EJqR4JlzaKLw4slmfYkWRLwJsi1pS/9DbIF7FvbHzsBS/ukRgAXZcgAzJChGYYMVExuo4A1sNM0Lo2AU6J3LhZDueSV6WwAnByZNAXYG4O/frcEdspxw0AWnQeaHUWpfy3xNwlxGJT4+1DkWvVeDuz0Q0Lj93eOlmkJrtWLweG5luya9FoK7Do71OcfDWjkhUeC1A6L5uhoFQaoNgeWRoXb9aL8DUvnudpsuaEsPVOjwemhKoB/7FYgAHtlWoMqlUiFGRVur2Ho5QmUysApA6a+/iz5fZNMe0Fb5sBUBo2bHI/Oa/+vP915ZcaCPyR4vQrUF8i0BlnzXmsHC7dNgfldLfHfloBLQn2xTFsAc21J6wY7bZstXuw3BS8JlQNMeDFONnq4TWlhFmHaZMmaqSSI6gtr5SjcDupBMm1pX2YBdDbABSLGUjVqYqY894U6KNPWzlYWIFrqXAy2Ko3/FFDHZZqDDIbYV5TzZAQLQplzzZLm5HLJ0qfORtj4fdr+qm9dpX8fxoA6IWQKakrGL2NTbcKA+nrAGuSklDopMWM4yksD6lyQpXjpGpgH1Lkga2CTBjSgzgHYClWFGVDnhvwDbPw7obCwsLCwsPPtrwADAIuEVbjhYHFkAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_914_900",
    width: 58,
    height: 38,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAmCAYAAACVr4jIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAj9JREFUeNrsmQ1uwyAMhTHNXXb/4+wuC147hcpyn39oWBtVsYTSRAnqxzPYmFJO+yyjPR9/M8s++Ivoc0AVXMYOMQC0AzDzLR8FmnYAomccgb4LPAOqgQjAkgFkXV8OTQNqUtCQ27KCzIJPh16SAyGBqnHVLqxBWwCPBnkaNCXUtCAv27UCZRm0ZjyP4KcovQwMAgHIi/itXRhBNgDdAmgkwDDwMqC8BJWQCFarIwHbE+AP0KPASxIwC0wGrAdqwWfUpitwCnbZMbclrG7IhZsD3ZKD0J+XUdhlYpjSC5Y1X7Owva3qvijgFGwEykHYQC5VgiwqC9wBq/i9bn01EbLusFaoikDZAUR/SqrYXdia573PakCv25xfRV8/zv/7u78tUJaqJujtAxG0kRKrkfr1Bao5cbaAuFtF31VAkiOCVtFUNTNHdfBuxjtdXQ1Zwdy1oBm4PKvBaMoTXJcdmaOk0jj0zkW5cQ1W5OrkydL9WV2rgC2J3VMOdHNfC1bP2wrcdQQYKZjJ1KYo6sGSclsyIOlJddnYCPzL7sWDleqSWParEVMtyOooyyCWZsLa8wkDgGWwjZNqW7DkqE5OVoVgpyf1d9ger4C6DKApCU4JVXUiMaTszHJnMWpJ2QoFalGi8gBrJQzT6hVJ6Cx8MdYDdyt3heR/UXRHeZQCeCs/Lt62zUvqX1JrHFS7GKDFK7JF27SXV5MT0N4zfraO9PazAueIg6K8e6RudLhTocTZzqEPs0477bTTTrvZrwADAP77tDLbxu/CAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_914_900",
    width: 117,
    height: 58,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAA6CAYAAACOChYFAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABBhJREFUeNrsnGuO4jAQhNtO7rL3P87ehdj7B1Y9pqsfickE6JaiBDJopHyq6ocNRBkZGRkZGRkZGWKUfATnx9/evc++/yklob4ZRO35971wE+rvQvRADcNNqOdBlK6LA+bT2QK7JpKpIDVwBbyHgPbhdRnOqdRfhKi9JgESB9qG8//7mlpTqa+BWAyoRYD6gMZBPl7XAayq1lTqfpDeoxpACShzu5/5wVUM1bomyO4taB7X1QmwCn9blVzK4Y33iqBOqNY1IUIrJSe4EWBVoJbhf3PLfaiT23HZ46ZrgnRZKoI3XktgUQ7l+bMMMB85VPvs90EN2qplodaB1IqAcCW2gCr7Vyn1gK16IC7gWlMmKVbbmRIlYF04vsN+J9mqBnIxoFogJUBFeK8ZlW5IteuX2+pigByhLgpMBJKEtmVjZ37cQCvzBPnthw8KyCO2uiggkUoraE360JqMYBFE62h7LHhNWxUhLgBmUXrMrqixBSBuDivubwH1AMi9toqsVsqbUn/ZDTW2AEQEUgRqrdKUi9qqF+RRWx1BSpXsGG0objiUW0CRkiolkCGgvwLVAdKbH5dJtlqVvpJApWoVOuN1UwqgZoGMAD0NarDQqY78uEyy1Wr0lGjI7gG5AWvtBsjdOx5eDtUJMmKtCN4RW5WqV9Q7cqAI3k3JkZq90gyYL4HqtNZIfvTC3Gurkhq7kPc2A2oDyuwAJhnV7C6Y06AGc2R1qjECc4atNgCyOdsPT/VKYCAxBeQUqIa9jtfeatVT5ERAemy1GapDrUekcn05yENQB5hWntQUaYHTxnRekB5b9UCM5sjpefIlUIEyx3yF1hcjeRGN56zJzlFbRYOATahWLwcyDFVRJ2o/FkWZa7DYKcaIjibbqtVDNrL35p4OMgRVAKrZq9Y/rk51aoUOOZatZtlqV+aup+bIaKwB8BLMRcmTi0OhaDmLwLqjZK9n2+olQbqVylSKJjwWvDVgsaQMzaVCpxl9YtRWvfnxkiAjSkWFEcqTK4BaFZhoMdma6myO96K2+rYgXVDvKkUDBK7UVYEqWWxhqx2jnbWdML/CVmcoVVrb1Abt2sIyf4gbWMqyYHot9WNtdWahRI75rdR2cFCFnbtwH33dILps9dG2Ohuq66vs9HOPDtHzNkgyqtgWUGJo6eqTIe6F2h3z1HIH0hWYWt5syr2etvo6++VgKlPWCF8bGDRguxrAtNVJUDvoG3mOHGeufPukpmrt7FXj19nqrOEDWgtFuwrQrjsSwO2x01TjZPvtoL+sQw4tAGinfTkxQU6Gin44gn9Tq5G9gkIJ8SL2yyZLnh+jKAZQ1UYT5IlQAdjxs9rvASXEK0IVwIY+mxAvClWB6wabIC8K1QE44WVkZGRkZGRkZGRknBT/BBgAwitIc+Ob1SQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_914_900",
    width: 117,
    height: 54,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAA2CAYAAAD5yNZ+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABB1JREFUeNrsnAuSGyEMRBmYu+T+x8ldDKSSilMs6ZYE8/dKVdTY3v8+tz4NdggeHh4eHh4eHh4eT4iftf5ZW2Lxf+N18Ab///XHsjjUh0DUGNRRsA71eohWqGa4DvV4kAu4rT1WwfW/xxjY1VGcCnEhtxHUHmT5e126qyv1YIgaQLQkoLUDWnr1IrW6Uo9TI1pRANum1tKBfD8WO7BQra7UcyBGA9Reme+Vu/ulV3KvVleqDnIrRA1saJRYO5gt7PZravd7VoeKQS5CXZyFGMnHUNotAtAy8retrkZVjRHc18BJMGOnsBZc7iCz2vt9oe6gRgsstpCSg6DQMKPKbwF1A8gI1IhWUiAyVWpzKBtn+s9ljtPnQJ1MqyylMoBJgKp1tQgma47YonA/Zk7dmFajAWRSoCJVshGRqTE3dfT3ejW3MxhlrMp9DtQd0mocAJkIUKmDDYorhDrcHuiLAEZgAwO7PhzkSFpNRpAzMBE4llYzgMpAIqD/fuZjDH0BJLpGoyIlFaL7DKTk0RbBCcoEaFFSLq2p0tbbekOIVhfHUhslFUogo+LNSnZeFhTHrkWooYXU5XtBPQBkAmk1KWnVAnKZBJmVVJqFNC2NM/c6+bBzo5MUNaYJNUqq1EC+DDARyGoBOQL0cKgTjc5eIBMAmRR3B4Gsg80Nqo15ACRLsWagh0DduWOVutR1YBTpYaLOtSgNjwYRqfM0kIdAVbpWCWSvSmt9XIkao+K5srSK6l5WoJbBrpXNmLvA3AXqJMhRRwdBRIpchBFkNK0WoxJRxzqqyF1A7gK1A2qx5jRz3Formf8aiCr79GrtWJkSbwlyM1QA1AoyKf6q9DjbGUGjRyAgrTCZEssVNfJQqII6o2DNSQqMg+Z5DPoJPHQsxDKKaLPkrUFuMR+kEQSpcp1Ip4ti0bUn7oLStWaDSaAp0uLsXA5ySqmNShnQHtJKrmnAmluUHRBp/ChCbczK3iXbETmsYz0dKki7kQB9w1vJbQ2mtBdphTnir2qpNTwF5Ez6ZQeyGNB+JWEHJAAlSDWyGnZAkAFw6471qpqqdbgIbA9Tqo/V4O5YtrUKMcu1sz+PBjkEFbyq2TqDMmvurTRLjWRpU6qJ7AlSn9LonKHUZUC5CGB75LEYtrOs4Kzp9NH18YyRxhLtQWR039rBSql0qxo/DuReUNnBqhZmNHqweyhRU+NHg9xTqS3IDGBGZcasSoc62qV+S4gzUGvQD1wxdWpfV5UOtVisOAc5Zz5I22jI3kPebFDqoKRGh3hA+q2g8Ynh6wt7lvD1lVos7YaJedFBHuT9SrszIciHt4KgPod4YaOE3hmkBL5BrQGr4Ps7yDOV2rhL2nsAsSdEcIg3hGqAOwTVId4IKgGrpm+H+MDY421NPTw8QPwSYADmpk/Wu3PmSwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEaas);
export default __webpack_public_path__ + "static/media/eaas.a7a1ca597c53eb521354ab51fd41f94f.svg";
export { ForwardRef as ReactComponent };